<div class="permission-tree">
  <div class="mb-4">
    <p class="text-sm text-gray-600">
      <strong>{{ getSelectedCount() }}</strong> permissão(ões) selecionada(s)
    </p>
  </div>

  <div class="border border-gray-300 rounded-lg p-4 max-h-96 overflow-y-auto">
    <ul class="space-y-1">
      <li *ngFor="let node of nodes" class="permission-node">
        <app-permission-node
          [node]="node"
          (toggleExpand)="toggleExpand($event)"
          (toggleSelection)="toggleSelection($event)">
        </app-permission-node>
      </li>
    </ul>
  </div>
</div>
